import { forwardRef, type InputHTMLAttributes } from 'react';

interface ProfileFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  label: string;
  error?: string;
  wrapperClassName?: string;
}

export const ProfileField = forwardRef<HTMLInputElement, ProfileFieldProps>(
  ({ label, error, wrapperClassName, required, id, name, className, ...props }, ref) => {
    const inputId = id ?? name;

    return (
      <div className={`lms-profile-field space-y-2 ${wrapperClassName ?? ''}`}>
        <label htmlFor={inputId} className="block text-sm font-medium text-dash-on-surface-variant">
          {label}
          {required && <span className="text-danger-500"> *</span>}
        </label>
        <input
          ref={ref}
          id={inputId}
          name={name}
          required={required}
          className={`form-input-base w-full ${error ? 'border-danger-500' : ''} ${className ?? ''}`}
          {...props}
        />
        {error && <p className="text-xs text-danger-600">{error}</p>}
      </div>
    );
  },
);

ProfileField.displayName = 'ProfileField';
